"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bigIntReplacer = bigIntReplacer;
exports.bigIntAndDateAndBufferReviver = bigIntAndDateAndBufferReviver;
exports.base64ToUint8Array = base64ToUint8Array;
exports.jsonStringify = jsonStringify;
exports.jsonParse = jsonParse;
exports.tryStringify = tryStringify;
exports.tryConvertDates = tryConvertDates;
const fast_safe_stringify_1 = __importDefault(require("fast-safe-stringify"));
const bigintRegex = /^bigint\((-?[\d]*)\)$/;
const buffer64Regex = /^buffer64\(-?([\d]*)\)$/;
function bigIntReplacer(key, value) {
    void key;
    if (typeof value === 'bigint') {
        return `bigint(${value.toString()})`;
    }
    return value;
}
function bigIntAndDateAndBufferReviver(key, value) {
    if (typeof value === 'string') {
        const bigIntMatch = bigintRegex.exec(value);
        if (bigIntMatch) {
            return BigInt(bigIntMatch[1]);
        }
        const bufferMatch = buffer64Regex.exec(value);
        if (bufferMatch) {
            return base64ToUint8Array(bufferMatch[1]);
        }
        if (key.endsWith('At') || key.endsWith('Date')) {
            return new Date(value);
        }
    }
    return value;
}
function base64ToUint8Array(base64) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(base64, 'base64');
    }
    else {
        return Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
    }
}
function jsonStringify(o, space) {
    // TODO: Use fastSafeStringify instead?
    return JSON.stringify(o, bigIntReplacer, space);
}
function jsonParse(s) {
    return JSON.parse(s, bigIntAndDateAndBufferReviver);
}
function tryStringify(o) {
    try {
        return typeof o === 'string' ? o : (0, fast_safe_stringify_1.default)(o);
    }
    catch {
        // E.g. due circular dependencies
        return undefined;
    }
}
const isISOString = (s) => {
    return typeof s === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/.test(s);
};
/**  Covert ISOString to Date recursively */
function tryConvertDates(item) {
    if (!item)
        return item;
    if (Array.isArray(item)) {
        return item.map(tryConvertDates);
    }
    else if (typeof item === 'object') {
        for (const key of Object.keys(item)) {
            item[key] = tryConvertDates(item[key]);
        }
        return item;
    }
    else if (isISOString(item)) {
        return item.endsWith('Z') ? new Date(item) : new Date(item + '.000Z');
    }
    else {
        return item;
    }
}
//# sourceMappingURL=data:application/json;base64,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